import React from "react";
import {ajustesResources, tagResources, validadorClienteResources} from "../endpoints";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {Autocomplete} from "@material-ui/lab";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import useToken from "../useToken";

class AgregarConteo extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            codigo:this.props.articulo,
            id_codigo_tipo:null,
            lote: null,
            cantidad:"",
            motivo:"",
            comentario:'',
            motivos:[],
            tag:this.props.tag,
            origen: this.props.origen,
            deshabilitar_boton: false,
            error_codigo:false,
            descripcion_codigo:'',
            user: useToken.getUser(),
            validadores:[],
            validador:null
        }
    }
    ajustesMotivos = () =>{
        ajustesResources.getMotivosAjustes().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            if (this.state.user && this.state.user.app === 'natura') {
                const defecto = result.find(m => m.id === 1) || null;
                this.setState({ motivos: result, motivo: defecto });
            } else {
                this.setState({ motivos: result });
            }
        }).catch(error=> {
            console.log(error)
        });
    }

    agregarConteo = () =>{
        this.setState({deshabilitar_boton:true})
        const datosConteo ={
            codigo: this.state.codigo,
            id_codigo_tipo: this.state.id_codigo_tipo,
            tag: this.state.tag,
            lote: this.state.lote,
            cantidad: this.state.cantidad,
            id_motivo: this.state.motivo.id,
            comentario: this.state.comentario,
            origen_ajuste: this.state.origen,
            usuario_afectado: this.state.validador?.cod_operador ?? null
        }
        tagResources.agregarConteo(datosConteo).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.message){
                this.props.refrescar(result.message,result.severity)
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.error(error);
            this.props.refrescar("Ha ocurrido un error inesperado", "error");
        });
    }

    obtenerValidadorCliente = () =>{
        this.setState({openSnack:false, severity: null, message:null})
        validadorClienteResources.getValidadorCliente().then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.status_code === 200){
                this.setState({validadores:result.validadores})
            }
            else if (result.status_code === 401){
                this.setState({cargando:false,openSnack:true, severity:result.severity, message:result.message})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
        });
    }

    componentDidMount() {
        this.ajustesMotivos()
        if(this.state.user.app === 'walmart' || this.state.user.app ==='walmart_parciales'){
            this.obtenerValidadorCliente();
        }
        if (this.props.articulo !== '' && this.props.articulo !== null){
            tagResources.verificaCodigoExiste(this.props.articulo).then(async response => {
                if (response.ok) {
                    return await response.json();
                } else {
                    throw new Error('Something went wrong ...');
                }
            }).then(result => {
                if (result === null){
                    this.setState({error_codigo:true})
                    this.setState({descripcion_codigo:''})
                }
                else{
                    let res = JSON.parse(JSON.stringify(result.value))
                    this.setState({error_codigo:false,descripcion_codigo:res.d, id_codigo_tipo: result.codigo_tipo})

                }
            }).catch(error=> {
                console.log(error)
            });
        }
    }

    handleChange = e =>{
        this.setState({[e.target.name]: e.target.value});
        if(e.target.name ==="codigo"){
            let value = e.target.value
            if (value === '' || value === null){
                value = null
            }
            tagResources.verificaCodigoExiste(value).then(async response => {
                if (response.ok) {
                    return await response.json();
                } else {
                    throw new Error('Something went wrong ...');
                }
            }).then(result => {
                if (result === null){
                    this.setState({error_codigo:true})
                    this.setState({descripcion_codigo:''})
                }
                else{
                    let res = JSON.parse(JSON.stringify(result.value))
                    this.setState({error_codigo:false,descripcion_codigo:res.d, id_codigo_tipo: result.codigo_tipo})

                }
            }).catch(error=> {
                console.log(error)
            });
        }
    }

    render() {
        return(
            <Dialog
                open={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">Agregar conteo</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} alignItems="flex-end">
                        {this.props.tag === '' && <Grid item xs={12}>
                            Tag: <TextField value={this.state.tag} name="tag" fullWidth onChange={this.handleChange}/>
                        </Grid>}
                        <Grid item xs={12}>
                            Código: <TextField error={this.state.error_codigo}
                                               helperText={this.state.error_codigo ? "Código no existe en maestro" : ""}
                                               value={this.state.codigo} name="codigo" fullWidth onChange={this.handleChange}/>
                        </Grid>
                        {this.state.descripcion_codigo !== '' && this.state.error_codigo !== true &&
                        <Grid item xs={12} style={{ border: "1px solid grey", borderRadius:'10px'}}>
                            {this.state.descripcion_codigo}
                        </Grid>}
                        {/* { this.state.user.app === 'natura' &&
                            <Grid item xs={12}>
                                Lote: <TextField value={this.state.lote} name="lote" fullWidth onChange={this.handleChange}/>
                            </Grid>
                        } */}
                        <Grid item xs={12}>
                            Cantidad: <TextField  type={"number"} value={this.state.cantidad} name="cantidad" fullWidth onChange={this.handleChange}/>
                        </Grid>
                        <Grid item xs={12}>
                            Seleccione un motivo:
                            <Autocomplete
                                value={ this.state.motivo}
                                onChange={(event, newValue) => {
                                    if(newValue === null) {
                                        this.setState({motivo: ""})
                                    }
                                    else{
                                        this.setState({motivo: newValue})
                                    }
                                }}
                                size="small"
                                options={this.state.motivos}
                                noOptionsText={"No hay opciones"}
                                getOptionLabel={(option) => option.descripcion|| ""}
                                renderInput={(params) => (
                                    <TextField {...params} variant="standard" label=" " placeholder="Disponibles"
                                               value={params.inputProps?.value ?? ""}/>
                                )}
                            />
                        </Grid>
                        {this.state.motivo.id === 4 && (this.state.user.app === 'walmart' || this.state.user.app === 'walmart_parciales' )&&
                            <Grid item xs={12}>
                            Comentario: <TextField value={this.state.comentario} name="comentario" fullWidth onChange={this.handleChange}/>
                        </Grid> }

                        { this.state.user.app === 'walmart' && this.state.user.perfil !== 'validador walmart' && this.state.user.perfil !== 'analista walmart' &&
                            <Grid item xs={12}>
                                Seleccione un validador:
                                <Autocomplete
                                    id="size-small-standard"
                                    value={ this.state.validador}
                                    onChange={(event, newValue) => {
                                        this.setState({ validador: newValue });
                                    }}
                                    size="small"
                                    options={this.state.validadores}
                                    noOptionsText={"No hay opciones"}
                                    getOptionLabel={(option) =>
                                        option ? `${option.nombre1} ${option.apellido1}` : ""
                                    }                                        renderInput={(params) => (
                                    <TextField {...params} variant="standard" label="Validador" placeholder="Disponibles"
                                               value={params.inputProps?.value ?? ""}/>
                                )}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                />
                            </Grid> }
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button disabled={this.state.deshabilitar_boton} variant="contained" color="secondary" onClick={this.props.handleClose}>
                        Cancelar
                    </Button>
                    <Button disabled={(this.state.motivo.id === 4 && !this.state.comentario && (this.state.user.app === 'walmart' || this.state.user.app === 'walmart_parciales')) || this.state.error_codigo || this.state.deshabilitar_boton || !this.state.codigo || !this.state.tag || !this.state.motivo || !this.state.cantidad}
                            variant="contained" onClick={this.agregarConteo} color="primary">
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default AgregarConteo;